import { createResponseTransformer } from "shared/api/createResponseTransformer"
import { serializer } from "shared/api/serializer/serializer"
import { transformJsonApiResponse } from "shared/api/transformJsonApiResponse"
import { ProjectHistoryEntriesAPIType } from "shared/types/Project"
import {
  ProjectHistoryEntry,
  ProjectHistoryLinks
} from "shared/types/__generated__/graphql"

/**
 * What the REST endpoint contributes to the `projectHistory` GraphQL field.
 * `id` and `__typename` are on the generated `ProjectHistory` but not here —
 * apollo-link-rest fills those in from the query, so the transformer never sees
 * them.
 */
export interface ProjectHistoryResponse {
  entries: ProjectHistoryEntry[]
  links: Pick<ProjectHistoryLinks, "prev" | "next">
}

export const projectHistoryResponseTransformer = createResponseTransformer(
  (json): ProjectHistoryResponse => {
    // json-api-serializer declares `deserialize` as `any`, so the entry shape is
    // asserted once here rather than leaking into the return type. The registered
    // `afterDeserialize` for this type has already mapped `entityType`.
    const entries = serializer.deserialize(
      ProjectHistoryEntriesAPIType,
      transformJsonApiResponse(json)
    ) as ProjectHistoryEntry[]

    return {
      entries,
      links: json.links ?? { prev: null, next: null }
    }
  }
)
